<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs3>
          <h2 class="headline font-weight-light">Collection Book</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4>
          <v-autocomplete
            class="white--text"
            solo
            :autofocus="true"
            label="Search Customer"
            prepend-inner-icon="search"
            v-model="selectedBuyer"
            :items="getBuyerName"
            @keyup.native="keymonitor($event)"
            clearable
            flat
            hide-details
            hide-no-data
            single-line
          >
          </v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click="printReport()">
          <v-icon class="white--text">print</v-icon>
        </v-btn>

        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>

      <!-- firm and Date filter -->
      <v-toolbar class="mb" color="white--text" flat>
        <v-layout row>
          <!-- <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerVillage"
              label="Select Village"
              v-model="selectedVillage"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerBlocks"
              label="Select Block"
              v-model="selectedBlock"
            ></v-autocomplete>
          </v-flex> -->
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerAddress"
              label="Select Address"
              v-model="selectedAddress"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerTehsil"
              label="Select Tehsil"
              v-model="selectedTehsil"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerDistrict"
              label="Select District"
              v-model="selectedDistrict"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-autocomplete
              dense
              flat
              clearable
              item-text="text"
              :items="getBuyerStates"
              label="Select State"
              v-model="selectedState"
            ></v-autocomplete>
          </v-flex>
          <v-flex>
            <v-text-field
              v-model="dayDiff"
              label="Day Difference"
              dense
              flat
              type="number"
              clearable
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <!-- End of Firm and Date Filter -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn color="primary" dark @click="expand = !expand">
            {{ expand ? "Close" : "Keep" }} other rows
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="buyerHeader"
            :items="getBuyers"
            item-key="name"
            class="elevation-1 dashboardHead"
            :expand="expand"
          >
            <template slot="items" slot-scope="props">
              <template
                v-if="
                  !!parseInt(props.item.remainingBalance) && !props.item.isTotal
                "
              >
                <tr @click="props.expanded = !props.expanded">
                  <td class="text-xs-left nowrap">
                    <router-link
                      style="text-decoration: none"
                      :to="'/buyers/' + props.item['.key']"
                    >
                      <b class="font-weight-bold primary--text">{{
                        props.item.name || "-"
                      }}</b>
                    </router-link>
                  </td>
                  <td class="text-xs-left nowrap">
                    <b class="font-weight-bold red--text">{{
                      props.item.remainingBalance | amount
                    }}</b>
                  </td>
                  <td class="text-xs-left nowrap">
                    <b>{{ props.item.mobile || "-" }}</b>
                  </td>
                  <!-- <td class="text-xs-left nowrap">
                  <b>{{ props.item.village || '-' }}</b>
                </td>
                <td class="text-xs-left nowrap">
                  <b>{{ props.item.block || '-' }}</b>
                </td> -->
                  <td class="text-xs-left nowrap">
                    <b>{{ props.item.localAddress || "-" }}</b>
                  </td>
                  <td class="text-xs-left nowrap">
                    <b>{{ props.item.tehsil || "-" }}</b>
                  </td>
                  <td class="text-xs-left nowrap">
                    <b>{{ props.item.district || "-" }}</b>
                  </td>
                  <td class="text-xs-left nowrap">
                    <b>{{ props.item.state || "-" }}</b>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'CustomerPayments',
                        params: { customerId: props.item['.key'] },
                      }"
                    >
                      <v-btn color="primary">RECEIPT</v-btn>
                    </router-link>
                  </td>
                </tr>
              </template>
              <template v-else-if="props.item.isTotal">
                <td class="text-xs-left nowrap">
                  <b class="font-weight-bold primary--text">Total</b>
                </td>
                <td class="text-xs-left nowrap">
                  <b class="font-weight-bold red--text">{{
                    Number.parseFloat(props.item.total).toFixed(2) | amount
                  }}</b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td class="text-xs-left nowrap">
                  <b></b>
                </td>
                <td></td>
              </template>
            </template>
            <template v-slot:expand="props">
              <div
                v-for="(inv, index) in props.item.invoices"
                :key="inv['.key'] + index"
              >
                <v-layout row wrap>
                  <v-flex xs3>
                    <span>{{
                      new Date(inv.date).toLocaleDateString("en-GB")
                    }}</span>
                  </v-flex>
                  <v-flex xs3>
                    <span class="success--text text--darken-1">{{
                      inv.credit
                    }}</span>
                  </v-flex>
                  <v-flex xs3>
                    <span class="error--text text--darken-1">{{
                      inv.debit
                    }}</span>
                  </v-flex>
                  <v-flex xs3>
                    <span>{{ inv.RunningBal }}</span>
                  </v-flex>
                </v-layout>
              </div>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { collectionBookReport } from "./../../../utils/pdf-reports/collectionBookReport.js";
export default {
  data() {
    return {
      buyerHeader: [
        { text: "Buyer Name", value: "name", sortable: true },
        { text: "Remaining Amount", value: "invoiceId", sortable: true },
        { text: "Mobile No.", value: "name" },
        // { text: "Village", value: "village" },
        // { text: "Block", value: "block" },
        { text: "Address", value: "localAddress" },
        { text: "Tehsil", value: "tehsil" },
        { text: "District", value: "district" },
        { text: "State", value: "state" },
        { text: "Receipt", value: "name" },
        // { text: "Payment", value: "" },
      ],
      selectedAddress: null,
      selectedBlock: null,
      selectedDistrict: null,
      selectedState: null,
      dayDiff : null,
      selectedTehsil: null,
      selectedVillage: null,
      selectedBuyer: null,
      buyers: [],
      expand: false,
    };
  },
  created() {
    this.$bindAsArray(
      "buyers",
      this.$root.$firebaseRefs.buyer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "customerDeposit",
      this.$root.$firebaseRefs.customerDeposit
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "customerPayments",
      this.$root.$firebaseRefs.customerPayments
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "invoiceHistories",
        this.$root.$firebaseRefs.invoiceHistory
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.$bindAsArray(
      "customerDeposit",
      this.$root.$firebaseRefs.customerDeposit
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    getBuyerBlocks() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.block)
            return {
              text: item["block"],
              value: item["block"],
            };
        });
    },
    getBuyerVillage() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.village)
            return {
              text: item["village"],
              value: item["village"],
            };
        });
    },
    getBuyerAddress() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.localAddress)
            return {
              text: item["localAddress"],
              value: item["localAddress"],
            };
        });
    },
    getBuyerTehsil() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.tehsil)
            return {
              text: item["tehsil"],
              value: item["tehsil"],
            };
        });
    },
    getBuyerDistrict() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.district)
            return {
              text: item["district"],
              value: item["district"],
            };
        });
    },
    getBuyerStates() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.state)
            return {
              text: item["state"],
              value: item["state"],
            };
        });
    },
    getBuyerName() {
      return this.buyers
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (!!item.name)
            return {
              text: item["name"],
              value: item["name"],
            };
        });
    },
    getBuyers() {
      let total = 0;
      let buyers = this.buyers.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedBuyer ? item["name"] == this.selectedBuyer : true) &&
          (this.selectedAddress
            ? item["localAddress"] == this.selectedAddress
            : true) &&
          (this.selectedBlock ? item["block"] == this.selectedBlock : true) &&
          (this.selectedDistrict
            ? item["district"] == this.selectedDistrict
            : true) &&
          (this.selectedVillage
            ? item["village"] == this.selectedVillage
            : true) &&
          (this.selectedState ? item["state"] == this.selectedState : true) &&
          (this.selectedTehsil ? item["tehsil"] == this.selectedTehsil : true)
      );
      buyers.map((buyer, bIndex) => {
        let temp = this.getRemainingBalanceAmount(buyer);
        buyers[bIndex]["remainingBalance"] = temp.amount;
        buyers[bIndex]["invoices"] = temp.invoices;
        // buyers[bIndex]["remainingBalance"] = 0;
        // let invoices = this.invoices.filter((item) => {
        //   return (
        //     item["brand"] === this.selectedBrand &&
        //     item["status"] != "paid" &&
        //     item.date >= this.finYear.start &&
        //     (item.deleted != true) &&
        //     item.date <= this.finYear.end &&
        //     item.buyerId == buyer['.key']
        //   );
        // });
        // invoices.map((invoice, Iindex) => {
        //   buyers[bIndex]["remainingBalance"] += invoice.remainingAmount ? Number.parseFloat(
        //     invoice.remainingAmount
        //   ) : 0;
        // });
        // buyers[bIndex]["remainingBalance"] +=  buyer.remainingAmountFromDeposite?  Number.parseFloat(
        //   buyer.remainingAmountFromDeposite
        // ) : 0;
        //   buyers[bIndex]["remainingBalance"] =  Number.parseFloat(buyers[bIndex]["remainingBalance"]).toFixed(2)
        total += Number.parseFloat(buyers[bIndex]["remainingBalance"]);
      });
      buyers = buyers.filter((item) => !!item.remainingBalance);
      buyers.push({
        isTotal: true,
        total: total,
      });
      return buyers;
    },
  },
  methods: {
    printReport() {
      let doc = collectionBookReport({
        buyers: this.getBuyers,
      });
      pdfMake.createPdf(doc).download();
    },
    keymonitor(event) {
      this.search = event.target.value;
    },
    getRemainingBalanceAmount(buyer) {
      let filteredInvoice = this.invoiceHistories.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === buyer[".key"] &&
          !item["deleted"] &&
          (item["returnStatus"]
            ? item["returnStatus"] == "remaining" && item["status"] == "paid"
            : true) &&
          (item["isLatest"] != undefined ? item["isLatest"] == true : true)
      );
      let payments = this.customerPayments.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === buyer[".key"] &&
          Number.parseFloat(item["remainingAmount"]) > 0
      );

      let customerDeposit = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === buyer[".key"] &&
          (item["type"] === "Advance" ||
            item["type"] === "Opening Balance" ||
            item["type"] === "LoanTaken" ||
            item["type"] === "LoanGiven" ||
            item["type"] === "Security")
      );

      filteredInvoice.map((item, index) => {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (
          item.newlyCreated &&
          (item.status === "paid" || item.status === "partial")
        ) {
          let newItem = JSON.parse(JSON.stringify(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = "due";
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem["newlyCreated"];
          filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          filteredInvoice[index].date = item.closedDate;
        }
      });

      customerDeposit.map((deposit, index) => {
        filteredInvoice.push(deposit);
        if (
          (deposit["type"] === "LoanTaken" ||
            deposit["type"] === "LoanGiven") &&
          deposit.status == "paid" &&
          !deposit.loanTransaction
        ) {
          customerDeposit[index].status = "due";
        }
      });

      payments.map((pay) => {
        pay["type"] = "CustomerPayment";
        filteredInvoice.push(pay);
      });
      if(this.dayDiff) {
        let date = new Date();
        
        filteredInvoice = filteredInvoice.filter(i =>{
          if(i.date) {
            const diffTime = Math.abs(date - i.date);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            return (diffDays >= this.dayDiff)
          }
          return false;
          
        })
      }
      filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      let invoices = [];
      filteredInvoice.map((item, index) => {
        filteredInvoice[index]["debit"] = this.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = this.getCredit(
          filteredInvoice[index]
        );
        if (item.isBuyer) {
          let temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] =
          Number.parseFloat(filteredInvoice[index]["debit"] || 0) -
          Number.parseFloat(filteredInvoice[index]["credit"] || 0) +
          (index == 0
            ? 0
            : Number.parseFloat(filteredInvoice[index - 1]["RunningBal"]));
        invoices.push(item);
      });
      return filteredInvoice.length
        ? {
            amount: filteredInvoice[filteredInvoice.length - 1]["RunningBal"],
            invoices: invoices,
          }
        : {
            amount: 0,
            invoices: [],
          };
    },
    getDebit(item) {
      if (item.type == "CustomerPayment") {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (
        [
          "LoanTaken",
          "LoanGiven",
          "Opening Balance",
          "Advance",
          "Security",
        ].includes(item.type)
      ) {
        switch (item.type) {
          case "LoanTaken": {
            if (item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case "LoanGiven": {
            if (item.loanTransaction) {
              if (item.loanPaymentType == "interest") {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case "Opening Balance": {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case "Advance": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
          case "Security": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
        }
      } else {
        switch (item.status) {
          case "due": {
            return 0;
            break;
          }
          case "paid": {
            // return (Number.parseFloat(item['totalAmount']));
            return (
              Number.parseFloat(item["amountFromBank"]) +
              Number.parseFloat(item["amountFromCash"])
            );
            break;
          }
          case "partial": {
            return (
              Number.parseFloat(item["amountFromBank"]) +
              Number.parseFloat(item["amountFromCash"])
            );
            break;
          }
        }
      }
    },
    getCredit(item) {
      if (item.type == "CustomerPayment") {
        if (item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (
        [
          "LoanTaken",
          "LoanGiven",
          "Opening Balance",
          "Advance",
          "Security",
        ].includes(item.type)
      ) {
        switch (item.type) {
          case "LoanTaken": {
            if (item.loanTransaction) {
              if (item.loanPaymentType == "interest") {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case "LoanGiven": {
            if (item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case "Opening Balance": {
            return item.isUserCreated
              ? Number.parseFloat(item.amount)
              : Number.parseFloat(0);
            break;
          }
          case "Advance": {
            return item.isUserCreated
              ? Number.parseFloat(0)
              : Number.parseFloat(item.settledAmount);
            break;
          }
          case "Security": {
            return item.isUserCreated
              ? Number.parseFloat(0)
              : Number.parseFloat(item.settledAmount);
            break;
          }
        }
      } else {
        switch (item.status) {
          case "due": {
            return item.totalAmount;
            break;
          }
          case "paid": {
            return 0;
            break;
          }
          case "partial": {
            return 0;
            break;
          }
        }
      }
    },
    // getDebit(item) {
    //   if (item.type == "CustomerPayment") {
    //     if (!item.isBuyer) {
    //       return 0;
    //     } else {
    //       return item["remainingAmount"];
    //     }
    //   } else if (
    //     [
    //       "LoanTaken",
    //       "LoanGiven",
    //       "Opening Balance",
    //       "Advance",
    //       "Security",
    //     ].includes(item.type)
    //   ) {
    //     switch (item.type) {
    //       case "LoanTaken": {
    //         if (item.loanTransaction) {
    //           return 0;
    //         } else {
    //           return Number.parseFloat(item.amount);
    //         }
    //         break;
    //       }
    //       case "LoanGiven": {
    //         if (item.loanTransaction) {
    //           if (item.loanPaymentType == "interest") {
    //             return Number.parseFloat(item.paidInterest);
    //           } else {
    //             return Number.parseFloat(item.paidAmount);
    //           }
    //         } else {
    //           return 0;
    //         }
    //         break;
    //       }
    //       case "Opening Balance": {
    //         if (item.status == "due") {
    //           return item.isUserCreated
    //             ? Number.parseFloat(0)
    //             : Number.parseFloat(item.amount);
    //         } else if (item.status == "paid" || item.status == "partial") {
    //           return item.isUserCreated
    //             ? Number.parseFloat(0)
    //             : Number.parseFloat(item.settledAmount);
    //         } else {
    //           return 0;
    //         }
    //         break;
    //       }
    //       case "Advance": {
    //         return item.isUserCreated
    //           ? Number.parseFloat(item.amount)
    //           : Number.parseFloat(0);
    //         break;
    //       }
    //       case "Security": {
    //         return item.isUserCreated
    //           ? Number.parseFloat(item.amount)
    //           : Number.parseFloat(0);
    //         break;
    //       }
    //     }
    //   } else {
    //     switch (item.status) {
    //       case "due": {
    //         return 0;
    //         break;
    //       }
    //       case "paid": {
    //         return (
    //           Number.parseFloat(item["amountFromBank"]) +
    //           Number.parseFloat(item["amountFromCash"])
    //         );
    //         break;
    //       }
    //       case "partial": {
    //         return (
    //           Number.parseFloat(item["amountFromBank"]) +
    //           Number.parseFloat(item["amountFromCash"])
    //         );
    //         break;
    //       }
    //     }
    //   }
    // },
    // getCredit(item) {
    //   if (item.type == "CustomerPayment") {
    //     if (item.isBuyer) {
    //       return 0;
    //     } else {
    //       return item["remainingAmount"];
    //     }
    //   } else if (
    //     [
    //       "LoanTaken",
    //       "LoanGiven",
    //       "Opening Balance",
    //       "Advance",
    //       "Security",
    //     ].includes(item.type)
    //   ) {
    //     switch (item.type) {
    //       case "LoanTaken": {
    //         if (item.loanTransaction) {
    //           if (item.loanPaymentType == "interest") {
    //             return Number.parseFloat(item.paidInterest);
    //           } else {
    //             return Number.parseFloat(item.paidAmount);
    //           }
    //         } else {
    //           return 0;
    //         }
    //         break;
    //       }
    //       case "LoanGiven": {
    //         if (item.loanTransaction) {
    //           return 0;
    //         } else {
    //           return Number.parseFloat(item.amount);
    //         }
    //         break;
    //       }
    //       case "Opening Balance": {
    //         return item.isUserCreated
    //           ? Number.parseFloat(item.amount)
    //           : Number.parseFloat(0);
    //         break;
    //       }
    //       case "Advance": {
    //         return item.isUserCreated
    //           ? Number.parseFloat(0)
    //           : Number.parseFloat(item.settledAmount);
    //         break;
    //       }
    //       case "Security": {
    //         return item.isUserCreated
    //           ? Number.parseFloat(0)
    //           : Number.parseFloat(item.settledAmount);
    //         break;
    //       }
    //     }
    //   } else {
    //     switch (item.status) {
    //       case "due": {
    //         return item.totalAmount;
    //         break;
    //       }
    //       case "paid": {
    //         return 0;
    //         break;
    //       }
    //       case "partial": {
    //         return 0;
    //         break;
    //       }
    //     }
    //   }
    // },
  },
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
  color: #ffffff;
  background: #15155d;
  border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Informations/CollectionBook/collectionBook.vue